'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherMail } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog, TextArea } from '@/shared/components/ui';
import type { CanalEnvio, Fatura } from '../types';
const MAX_MENSAGEM = 200;
interface EnviarSegundaViaModalProps {
  isOpen: boolean;
  fatura: Fatura | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (canais: CanalEnvio[], mensagem: string | null) => void;
}
export function EnviarSegundaViaModal(t0) {
  const $ = _c(57);
  const {
    isOpen,
    fatura,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [enviaEmail, setEnviaEmail] = useState(true);
  const [mensagem, setMensagem] = useState("");
  const hasEmail = Boolean(fatura?.adminContact?.email);
  let t1;
  let t2;
  if ($[0] !== hasEmail || $[1] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setEnviaEmail(hasEmail);
        setMensagem("");
      }
    };
    t2 = [isOpen, hasEmail];
    $[0] = hasEmail;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!fatura) {
    return null;
  }
  let t3;
  if ($[4] !== enviaEmail || $[5] !== hasEmail) {
    t3 = enviaEmail && hasEmail ? ["EMAIL"] : [];
    $[4] = enviaEmail;
    $[5] = hasEmail;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const canais = t3;
  const mensagemValida = mensagem.length <= MAX_MENSAGEM;
  const podeConfirmar = canais.length > 0 && mensagemValida && !saving;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-brand-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherMail className="text-brand-600 h-5 w-5" /></div>;
    t5 = <h2 className="text-body-bold font-body-bold text-default-font">Enviar 2ª via</h2>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== fatura.numero || $[10] !== fatura.tenantNome) {
    t6 = <div className="flex items-start gap-3">{t4}<div>{t5}<p className="text-caption font-caption text-subtext-color mt-1">{fatura.tenantNome} · {fatura.numero}</p></div></div>;
    $[9] = fatura.numero;
    $[10] = fatura.tenantNome;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="text-caption font-caption text-subtext-color mb-2">O link de pagamento é reenviado por e-mail</p>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `flex items-center gap-3 rounded-[8px] bg-white p-3 transition-colors ${hasEmail ? "cursor-pointer hover:bg-neutral-50" : "cursor-not-allowed opacity-50"}`;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => setEnviaEmail(e.target.checked);
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = !hasEmail;
  let t11;
  if ($[14] !== enviaEmail || $[15] !== t10) {
    t11 = <input type="checkbox" checked={enviaEmail} onChange={t9} disabled={t10} className="accent-brand-600 h-4 w-4 rounded border-neutral-300" />;
    $[14] = enviaEmail;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FeatherMail className="h-4 w-4 text-neutral-500" />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="text-body font-body text-default-font">E-mail</span>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = fatura.adminContact?.email ?? "Sem e-mail cadastrado";
  let t15;
  if ($[19] !== t14) {
    t15 = <div className="flex flex-col">{t13}<span className="text-caption font-caption text-subtext-color">{t14}</span></div>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t11 || $[22] !== t15 || $[23] !== t8) {
    t16 = <div className="rounded-[12px] bg-neutral-50 p-4">{t7}<div className="flex flex-col gap-3"><label className={t8}>{t11}{t12}{t15}</label></div></div>;
    $[21] = t11;
    $[22] = t15;
    $[23] = t8;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <label className="text-sm font-medium text-neutral-700">Mensagem personalizada{" "}<span className="text-subtext-color font-normal">(opcional)</span></label>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e_0 => setMensagem(e_0.target.value);
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== mensagem) {
    t19 = <TextArea><TextArea.Input placeholder={"Adicione uma observa\xE7\xE3o para o cliente, se quiser"} value={mensagem} onChange={t18} rows={2} /></TextArea>;
    $[27] = mensagem;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== mensagem.length) {
    t20 = <p className="text-caption font-caption text-subtext-color">{mensagem.length}/{MAX_MENSAGEM} caracteres</p>;
    $[29] = mensagem.length;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t19 || $[32] !== t20) {
    t21 = <div className="flex flex-col gap-1.5">{t17}{t19}{t20}</div>;
    $[31] = t19;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== onClose || $[35] !== saving) {
    t22 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[34] = onClose;
    $[35] = saving;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== canais || $[38] !== mensagem || $[39] !== onConfirm) {
    t23 = () => onConfirm(canais, mensagem.trim() || null);
    $[37] = canais;
    $[38] = mensagem;
    $[39] = onConfirm;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  const t24 = !podeConfirmar;
  let t25;
  if ($[41] !== saving || $[42] !== t23 || $[43] !== t24) {
    t25 = <Button variant="brand-primary" size="medium" onClick={t23} loading={saving} disabled={t24}>Enviar 2ª via</Button>;
    $[41] = saving;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t22 || $[46] !== t25) {
    t26 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t22}{t25}</div>;
    $[45] = t22;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== t16 || $[49] !== t21 || $[50] !== t26 || $[51] !== t6) {
    t27 = <Dialog.Content className="max-w-lg"><div className="flex w-full flex-col gap-5 p-6">{t6}{t16}{t21}{t26}</div></Dialog.Content>;
    $[48] = t16;
    $[49] = t21;
    $[50] = t26;
    $[51] = t6;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== isOpen || $[54] !== onClose || $[55] !== t27) {
    t28 = <Dialog open={isOpen} onOpenChange={onClose}>{t27}</Dialog>;
    $[53] = isOpen;
    $[54] = onClose;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  return t28;
}